export type BusinessUnitType =
  | 'RESTAURANT'
  | 'PRODUCTION_KITCHEN'
  | 'CAFE'
  | 'BAKERY'
  | 'WAREHOUSE'
  | 'OTHER';

export type BusinessUnitStatus = 'ACTIVE' | 'OPENING' | 'ARCHIVED';

export interface BusinessUnit {
  id: string;
  name: string;
  type: BusinessUnitType;
  status: BusinessUnitStatus;
  sort_order: number;
}

export const UNIT_TYPE_LABELS: Record<BusinessUnitType, string> = {
  RESTAURANT: 'Ресторан',
  PRODUCTION_KITCHEN: 'Производственный цех',
  CAFE: 'Кафе',
  BAKERY: 'Пекарня',
  WAREHOUSE: 'Склад',
  OTHER: 'Другое',
};

export const isProduction = (unit: BusinessUnit): boolean => unit.type === 'PRODUCTION_KITCHEN';
